import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { Upload, File, Loader2 } from 'lucide-react';
import { supabase } from '../../lib/supabase';

export function DocumentScanner() {
  const onDrop = useCallback(async (acceptedFiles: File[]) => {
    for (const file of acceptedFiles) {
      const fileExt = file.name.split('.').pop();
      const fileName = `${Math.random()}.${fileExt}`;
      const filePath = `${fileName}`;

      try {
        // Upload to Supabase Storage
        const { data, error } = await supabase.storage.from('documents').upload(filePath, file);

        if (error) throw error;

        // Store metadata in document_storage table
        await supabase.from('document_storage').insert({
          file_name: file.name,
          file_type: file.type,
          file_size: file.size,
          file_url: data.path,
        });
      } catch (error) {
        console.error('Error uploading document:', error);
      }
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div className="bg-dark-card rounded-lg shadow p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-2">
          <File className="h-6 w-6 text-primary-400" />
          <h2 className="text-xl font-semibold text-dark-text">Document Scanner</h2>
        </div>
      </div>

      <div
        {...getRootProps()}
        className={`border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors
          ${isDragActive ? 'border-primary-400 bg-primary-400/10' : 'border-dark-border'}`}
      >
        <input {...getInputProps()} />
        <Upload className="h-12 w-12 text-dark-muted mx-auto mb-4" />
        <p className="text-dark-text font-medium">Drop files here or click to upload</p>
        <p className="text-dark-muted text-sm mt-2">
          Support for receipts, invoices, and other business documents
        </p>
      </div>
    </div>
  );
}
